'use client'

import { Flex, Box, Spacer, Text, IconButton, Center, useClipboard, Tooltip, BoxProps, Img } from '@/components/Chakra'
import useToast from '@/hooks/useToast'
import { FiLink } from 'react-icons/fi'
import { FacebookShareButton, TwitterShareButton, LineShareButton } from 'react-share'

type SocialShareAreaProps = {
  currentUrl: string
} & BoxProps

export const SocialShareArea = ({ currentUrl, ...outerBoxProps }: SocialShareAreaProps) => {
  const { onCopy } = useClipboard(currentUrl)
  const toast = useToast()

  const copy = () => {
    onCopy()
    toast({
      status: 'success',
      title: 'コピーしました',
    })
  }

  return (
    <Box {...outerBoxProps}>
      <Box
        borderRadius={['md', 'md', 'inherit']}
        background={['white', 'white', 'inherit']}
        px={[6, 6, 0]}
        py={[6, 6, 0]}
      >
        <Flex mt={[0, 0, 10]} direction={'row'} align={'center'}>
          <Box w={'25%'} as={'div'} height={'1px'} background={'black'}></Box>
          <Spacer />
          <Text textAlign={'center'} fontWeight={'bold'}>
            SNSにシェア
          </Text>
          <Spacer />
          <Box w={'25%'} as={'div'} height={'1px'} background={'black'}></Box>
        </Flex>
        <Center mt={4}>
          <Flex borderRadius={['md', 'md', 'inherit']} py={[6, 6, 0]} px={[6, 6, 0]} width={['100%', '80%', '80%']}>
            <Tooltip placement={'top'} closeDelay={500} label={'リンクをコピー'}>
              <IconButton
                isRound={true}
                icon={<FiLink />}
                color={'black'}
                bgColor={'gray.100'}
                _hover={{ bg: 'inheirt' }}
                aria-label=""
                onClick={() => copy()}
              />
            </Tooltip>
            <Spacer />
            <Tooltip placement={'top'} label={'Twitter'}>
              <TwitterShareButton url={currentUrl}>
                <IconButton
                  as={'a'}
                  isRound={true}
                  icon={<Img w={22} src="/icon/icon-twitter.svg" alt="" />}
                  color={'white'}
                  bgColor={'#1DA1F2'}
                  _hover={{ bg: 'inheirt' }}
                  aria-label=""
                />
              </TwitterShareButton>
            </Tooltip>
            <Spacer />
            <Tooltip placement={'top'} label={'Facebook'}>
              <FacebookShareButton url={currentUrl}>
                <IconButton
                  as={'a'}
                  isRound={true}
                  icon={<Img w={22} src="/icon/icon-facebook.svg" alt="" />}
                  color={'white'}
                  bgColor={'#4267B2'}
                  _hover={{ bg: 'inheirt' }}
                  aria-label=""
                />
              </FacebookShareButton>
            </Tooltip>
            <Spacer />
            <Tooltip placement={'top'} label={'LINE'}>
              <LineShareButton url={currentUrl}>
                <IconButton
                  as={'a'}
                  isRound={true}
                  icon={<Img w={22} src="/icon/icon-line.svg" alt="" />}
                  color={'white'}
                  bgColor={'#06C755'}
                  _hover={{ bg: 'inheirt' }}
                  aria-label=""
                />
              </LineShareButton>
            </Tooltip>
          </Flex>
        </Center>
      </Box>
    </Box>
  )
}
